import Vue from "vue"

export const imageViewerBus = new Vue()

export function openImageViewer(images, startIndex = 0, options = {}) {
  const normalized = (Array.isArray(images) ? images : [images])
    .map(item => typeof item === "string" ? item.trim() : "")
    .filter(Boolean)
  if (!normalized.length) return false
  const index = Math.max(0, Math.min(normalized.length - 1, Number(startIndex) || 0))
  imageViewerBus.$emit("image-viewer:open", { images: normalized, index, ...options })
  return true
}
